import { saveAs } from 'file-saver'
import html2canvas from 'html2canvas-pro'
import { PDFDocument } from 'pdf-lib'

export default async function generatePDF(customerName: string): Promise<void> {
  const pageElements = document.querySelectorAll<HTMLElement>('[data-pdf-page]')
  if (pageElements.length === 0) return

  const now = new Date()
  const date = now
    .toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: '2-digit',
    })
    .replace(/,?\s/g, '-')
  const time = now
    .toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    })
    .replace(/:/g, '-')
  const fileName = `${customerName}_${date}_${time}.pdf`

  await document.fonts.ready

  const pdfDoc = await PDFDocument.create()

  for (const el of Array.from(pageElements)) {
    const w = el.scrollWidth
    const h = el.scrollHeight
    if (w === 0 || h === 0) continue

    const canvas = await html2canvas(el, {
      backgroundColor: '#FFFFFF',
      foreignObjectRendering: false,
      scale: 2,
      scrollX: 0,
      scrollY: 0,
      useCORS: true,
      width: w,
      height: h,
    })

    if (canvas.width === 0 || canvas.height === 0) continue

    const dataUrl = canvas.toDataURL('image/jpeg', 0.92)
    const imgBytes = Uint8Array.from(atob(dataUrl.split(',')[1]!), (c) =>
      c.charCodeAt(0),
    )

    const image = await pdfDoc.embedJpg(imgBytes)
    const { width, height } = image.scale(1)

    const pdfPageWidth = 595.28
    const scaleFactor = pdfPageWidth / width
    const pdfPageHeight = height * scaleFactor

    const page = pdfDoc.addPage([pdfPageWidth, pdfPageHeight])
    page.drawImage(image, {
      x: 0,
      y: 0,
      width: pdfPageWidth,
      height: pdfPageHeight,
    })
  }

  const pdfBytes = await pdfDoc.save()
  saveAs(
    new Blob([pdfBytes.buffer as ArrayBuffer], { type: 'application/pdf' }),
    fileName,
  )
}
